<template>
  <div>
      <fieldset>
        <div class="row">
              <legend>Employee Information</legend>
          </div>
          <div class="row">
              <div class="small-12 medium-6 columns lp">
                  <labeled-input label="First Name *" name="Employee First Name" validation='required|max:20' v-model='sampleobject.firstName'></labeled-input>
              </div>
              <div class="small-12 medium-6 columns rp">
                  <labeled-input label="Last Name *" validation='required|max:20' name="Employee Last Name" v-model='sampleobject.lastName'></labeled-input>
              </div>
          </div>
      </fieldset>
  </div>
</template>
<script>
import LabeledInput from "@/components/shared/LabeledInput";

export default {
props: ["selected", "sampleobject"],
inject: ["$validator"],
components: { LabeledInput },
methods: {
  validatePhoneNumber() {
    const phone = this.sampleobject.phone;
    const formattedPhone = this.formatPhoneNumber(phone);
    this.sampleobject.phone = formattedPhone;
    if (formattedPhone) {
          const formattedPhoneDigits = formattedPhone.replace(/\D/g, '').length;
          if (formattedPhoneDigits === 10) {
              this.hasInvalidPhoneNumber = false;
          } else {
              this.hasInvalidPhoneNumber = true;
              this.invalidPhoneFormatMessage = "The Mobile Phone field must be 10 digits.";
          }
      } else {
          this.hasInvalidPhoneNumber = true;
      }

    this.$emit('hasInvalidPhoneNumber', this.hasInvalidPhoneNumber);
  },
  formatPhoneNumber(args) {
    var s2 = ("" + args).replace(/\D/g, "");
    var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    
    if (!m) {
      return args;
    } else {
      return "(" + m[1] + ") " + m[2] + "-" + m[3];
    }
  },
  validateEmail(email) {
    const emailFiltered = (email || "").toLowerCase().trim();

    if (emailFiltered == null) {
        return;
    }

    if (emailFiltered.includes("@essilorusa.com") || emailFiltered.includes("@essilorluxottica.com") || emailFiltered.includes("@essilorluxottica.id") || emailFiltered.includes("@midlandoptical.com") || 
        emailFiltered.includes("@essilor.com") || emailFiltered.includes("@luxottica.com") || emailFiltered.includes("@us.luxottica.com")) {
        this.hasInvalidEmail = false;
    } else {
        this.hasInvalidEmail = true;
    }

    this.$emit('hasInvalidEmail', this.hasInvalidEmail);
  },
  validateEmail(email) {
    const emailFiltered = (email || "").toLowerCase().trim();

    if (emailFiltered == null) {
      return;
    }
    if (emailFiltered.includes("@essilorusa.com") || emailFiltered.includes("@essilorluxottica.com") || emailFiltered.includes("@essilorluxottica.id") || emailFiltered.includes("@midlandoptical.com") || 
        emailFiltered.includes("@essilor.com") || emailFiltered.includes("@luxottica.com") || emailFiltered.includes("@us.luxottica.com")) {
            this.hasInvalidEmail = false;
          } else {
            this.hasInvalidEmail = true;
          }
          this.$emit('hasInvalidEmail', this.hasInvalidEmail);
      }
  },
created() {
},
data() {
  return {
    hasInvalidEmail: false,
    hasInvalidPhoneNumber: false,
    invalidEmail: `Please enter your employee email address.`,
    invalidPhoneFormatMessage: "The Mobile Phone field must be 10 digits.",
  };
},
watch: {
  'sampleobject.email': {
    handler: function(email) {
      this.validateEmail(email);
    },
    deep: true, 
    immediate: true
  },
  
},
};
</script>
